import { render } from "./BaseTwoColLayout.vue?vue&type=template&id=23609e3b&scoped=true"
import script from "./BaseTwoColLayout.vue?vue&type=script&lang=js"
export * from "./BaseTwoColLayout.vue?vue&type=script&lang=js"

import "./BaseTwoColLayout.vue?vue&type=style&index=0&id=23609e3b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23609e3b"]])

export default __exports__